import React, { Component } from "react";
import {
  Row,
  Col,
  Alert,
  Button,
  Container,
  FormGroup,
  Label,
} from "reactstrap";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { forgetUser, clearStore } from "../../store/actions";
import logodark from "../../assets/images/logo-main.png";

class ForgetPasswordPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
    };
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
    this.handleError = this.handleError.bind(this);
    this.redirectToResetPage = this.redirectToResetPage.bind(this);
  }

  redirectToResetPage() {
    const { username } = this.state;
    const { history } = this.props;
    const state = { email: username };
    this.props.clearStore();
    history.push("/reset-password", state);
  }

  handleValidSubmit(event, values) {
    this.props.forgetUser(values);
  }

  componentDidMount() {
    document.body.classList.add("auth-body-bg");
  }

  componentDidUpdate(prevProps) {
    // Check if loading changed from true to false and we have a message (success case)
    if (prevProps.loading && !this.props.loading && this.props.message) {
      console.log("Success case - message received:", this.props.message);
      this.redirectToResetPage();
    }
    
    // Check if we have an error and loading is false
    if (this.props.forgetError && !this.props.loading) {
      console.log("Error case - error received:", this.props.forgetError);
      this.handleError();
    }
  }

  handleError() {
    setTimeout(() => {
      this.props.clearStore();
    }, 5000);
  }

  render() {
    console.log("this.state.username = ", this.state.username);
    console.log("Props in render:", {
      loading: this.props.loading,
      message: this.props.message,
      forgetError: this.props.forgetError
    });

    return (
      <React.Fragment>
        <Container fluid className="p-0">
          <Row className="no-gutters">
            <Col lg={5}>
              <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                <div className="w-100">
                  <Row className="justify-content-center">
                    <Col lg={9}>
                      <div>
                        <div className="text-center">
                          <div>
                            <Link to="/" className="logo">
                              <img src={logodark} height="60" alt="logo" />
                            </Link>
                          </div>
                          <p className="text-muted">
                            Reset your password to CloudNova License Manager!
                          </p>
                        </div>
                        <div className="p-2 mt-5">
                          {this.props.forgetError && this.props.forgetError ? (
                            <Alert color="danger" className="mb-4">
                              {this.props.forgetError}
                            </Alert>
                          ) : null}
                          <AvForm
                            className="form-horizontal"
                            onValidSubmit={this.handleValidSubmit}
                          >
                            <FormGroup>
                              <AvField
                                name="useremail"
                                value={this.state.username}
                                onChange={(e) =>
                                  this.setState({ username: e.target.value })
                                }
                                type="email"
                                className="form-control"
                                id="useremail"
                                placeholder="Enter email"
                                validate={{ email: true, required: true }}
                              />
                            </FormGroup>
                            <div className="mt-4 text-center">
                              <Button
                                color="primary"
                                className="w-md waves-effect waves-light"
                                type="submit"
                                disabled={this.props.loading}
                              >
                                {this.props.loading ? "Loading..." : "Reset"}
                              </Button>
                            </div>
                          </AvForm>
                        </div>
                        <div className="mt-5 text-center">
                          <p>
                            Return to{" "}
                            <Link
                              to="/login"
                              className="font-weight-medium text-primary"
                            >
                              {" "}
                              Login Page{" "}
                            </Link>{" "}
                          </p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
            <Col lg={7}>
              <div className="authentication-bg">
                {/* bg-overlay */}
                <div className=""></div>
              </div>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { message, forgetError, loading } = state.forgetPassword;
  return { message, forgetError, loading };
};

export default withRouter(
  connect(mapStatetoProps, { forgetUser, clearStore })(ForgetPasswordPage)
);